import moment from "moment";
import Icon from "../Icon/Icon.js";
import { PassCodeContainer as StyledPassCodeContainer } from "./PassCodeContainer.styles.js";

import "./index.scss";

const currentYear = moment().format('YYYY');

const PassCode = ({
	loading,
	values,
	onKeyUpOtpInput,
	onPaste
}) => (
	<StyledPassCodeContainer className="doca flex flex-col">
		<StyledPassCodeContainer.InfoContainer>
			<div className="doca-mb-5">
				<p className="doca-text--bold doca-text--extra-large doca-text-center doca-mb-3">
					Verificação de segurança
				</p>
				<p className="doca-text--medium doca-text--base doca-text-center doca-mb-3">
					Valide sua identidade para ter acesso ao documento.
				</p>
				<p className="doca-text--medium doca-text--base doca-text-center">
					Digite os 05 primeiros dígitos do CPF do paciente ou do responsável cadastrado.
				</p>
			</div>
			<div className="doca-flex doca-justify-center doca-items-center doca-mb-5">
				<div className="doca-form__field doca-form__field--otp ">
					<input
						className="doca-form-control doca-form-control--otp opt-dimetions"
						type="tel"
						id="otp0"
						onKeyUp={(e) => onKeyUpOtpInput(e, 0)}
						onPaste={onPaste}
						name="otp0"
						value={values['otp0']}
						disabled={loading}
						maxLength={1}
					/>
					<input
						className="doca-form-control doca-form-control--otp opt-dimetions"
						type="tel"
						id="otp1"
						onKeyUp={(e) => onKeyUpOtpInput(e, 1)}
						onPaste={onPaste}
						name="otp1"
						value={values['otp1']}
						disabled={loading}
						maxLength={1}
					/>
					<input
						className="doca-form-control doca-form-control--otp opt-dimetions"
						type="tel"
						id="otp2"
						onKeyUp={(e) => onKeyUpOtpInput(e, 2)}
						onPaste={onPaste}
						name="otp2"
						value={values['otp2']}
						disabled={loading}
						maxLength={1}
					/>
					<input
						className="doca-form-control doca-form-control--otp opt-dimetions"
						type="tel"
						id="otp3"
						onKeyUp={(e) => onKeyUpOtpInput(e, 3)}
						onPaste={onPaste}
						name="otp3"
						value={values['otp3']}
						disabled={loading}
						maxLength={1}
					/>
					<input
						className="doca-form-control doca-form-control--otp opt-dimetions"
						type="tel"
						id="otp4"
						onKeyUp={(e) => onKeyUpOtpInput(e, 4)}
						onPaste={onPaste}
						name="otp4"
						value={values['otp4']}
						disabled={loading}
						maxLength={1}
					/>
				</div>
			</div>
		</StyledPassCodeContainer.InfoContainer>

		<footer className="doca-flex doca-items-center doca-justify-center doca-w-full doca-flex-col">
			<div
				className="doca-flex doca-items-center doca-justify-center doca-gap-4 doca-mt-6"
				style={{ marginBottom: "32px" }}
			>
				<i className="doca-icon doca-icon__lock doca-icon--regular doca-text--gray" />

				<span className="doca-text doca-text--extra-small doca-text--gray">
					Este site está protegido por reCAPTCHA e pela <br />
					<a
						id="privacy-link"
						target="_blank"
						rel="noreferrer"
						href="https://amigoapp.tech/politica-de-privacidade"
						style={{
							textDecoration: "underline",
							cursor: "pointer",
						}}
					>
						Política de Privacidade
					</a> e <a
						style={{
							textDecoration: "underline",
							cursor: "pointer",
						}}
						href="https://amigoapp.tech/termos-de-uso"
						id="terms-link"
						target="_blank"
						rel="noreferrer"
					>
						Termos de Uso do Google
					</a>
				</span>
			</div>

			<div className="doca-flex doca-items-center">
				<Icon name="amigo-logo-gray" marginRight={4} />
				<br />
				<span className="doca-text doca-text--extra-small doca-text--gray">
					Cuide mais e melhor.
				</span>
			</div>
			<div className="doca-flex doca-items-center doca-mt-2 doca-mb-4">
				<span className="doca-text doca-text--extra-small doca-text--gray">
					{currentYear}, AmigoTech S/A. Todos os direitos reservados.
				</span>
			</div>
		</footer>
	</StyledPassCodeContainer>
);

export default PassCode;
